import { render, staticRenderFns } from "./ScrollablePageLayout.vue?vue&type=template&id=508f0dc5&scoped=true&"
import script from "./ScrollablePageLayout.vue?vue&type=script&lang=js&"
export * from "./ScrollablePageLayout.vue?vue&type=script&lang=js&"
import style0 from "./ScrollablePageLayout.vue?vue&type=style&index=0&id=508f0dc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508f0dc5",
  null
  
)

export default component.exports